<template>
  <button v-if="estado=='1'"      class="btn btn-sm  btn-info"> <i class="fa fa-check"></i> &nbsp; ACTIVO</button>
  <button v-else-if="estado=='2'" class="btn btn-sm  btn-primary"> <i class="fa fa-users"></i> &nbsp; VISTO POR TODOS</button>
  <button v-else-if="estado=='3'" class="btn btn-sm  btn-secondary"><i class="fa fa-user"></i> &nbsp;  VISTO SOLO ADMINISTRADOR</button>
  <button v-else-if="estado=='0'" class="btn btn-sm  btn-warning"><i class="fas fa-exclamation"></i> &nbsp; INACTIVO </button>
  <button v-else-if="estado=='4'" class="btn btn-sm  btn-info"> OTRO</button>

</template>

<script>
export default {
    name:"EstadoComponent",
    props:['estado']

}
</script>

